import React from "react";
import { ACTION, APPEARANCE, SIZE, COLOR } from "../../../constants";
import Text from "../../basicComponents/Text";
import Button from "../../basicComponents/Button";
import {
  Overlay,
  ModalContainer,
  Header,
  Divider,
  ModalBody,
  ButtonRow
} from "./styles";

export default ({
  isOpen,
  onCancel,
  onConfirm,
  message,
  confirmText = ACTION.CONFIRM,
  cancelText = ACTION.CANCEL,
  textHeader
}) => {
  if (!isOpen) return null;
  return (
    <Overlay>
      <ModalContainer>
        <Header>
          {textHeader}
        </Header>
        <Divider />
        <ModalBody>
          <Text
            size={SIZE.MEDIUM}
            color={COLOR.TEXT_PRIMARY}
            text={message}
            textAlign="center"
          />
        </ModalBody>
        <Divider />
        <ButtonRow>
          <Button
            appearance={APPEARANCE.LINK}
            size={SIZE.MEDIUM}
            color={COLOR.TEXT_PRIMARY}
            text={cancelText}
            onClick={onCancel}
          />
          <Button
            appearance={APPEARANCE.PRIMARY}
            size={SIZE.MEDIUM}
            color={COLOR.PRIMARY}
            text={confirmText}
            onClick={onConfirm}
          />
        </ButtonRow>
      </ModalContainer>
    </Overlay>
  );
}; 